import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const campaignAPI = {
  getAll: () => api.get('/campaigns'),
  getOne: (id) => api.get(`/campaigns/${id}`),
  create: (data) => api.post('/campaigns', data),
  update: (id, data) => api.put(`/campaigns/${id}`, data),
  delete: (id) => api.delete(`/campaigns/${id}`),
  duplicate: (id, name) => api.post(`/campaigns/${id}/duplicate`, { name }),
  addContacts: (id, contactIds) => api.post(`/campaigns/${id}/contacts`, { contactIds }),
  removeContact: (id, contactId) => api.delete(`/campaigns/${id}/contacts/${contactId}`),
  getStats: (id) => api.get(`/campaigns/${id}/stats`),
  getConfig: (id) => api.get(`/campaigns/${id}/config`),
  saveConfig: (id, data) => api.post(`/campaigns/${id}/config`, data),
  unpauseContact: (campaignId, phoneNumber) => api.post(`/campaigns/${campaignId}/contacts/${phoneNumber}/unpause`),
  getFailedMessages: (id) => api.get(`/campaigns/${id}/failed-messages`),
  retryFailed: (id, messageLogIds = null) => api.post(`/campaigns/${id}/retry-failed`, { messageLogIds }),
  stop: (id) => api.post(`/campaigns/${id}/stop`),
};

export const messageAPI = {
  getAll: () => api.get('/messages'),
  getByCampaign: (campaignId) => api.get(`/messages/campaign/${campaignId}`),
  create: (data) => api.post('/messages', data),
  update: (id, data) => api.put(`/messages/${id}`, data),
  delete: (id) => api.delete(`/messages/${id}`),
  getLogs: (campaignId) => api.get(`/messages/logs/${campaignId}`),
};

export const contactAPI = {
  getAll: () => api.get('/contacts'),
  getOne: (id) => api.get(`/contacts/${id}`),
  create: (data) => api.post('/contacts', data),
  createBulk: (contacts) => api.post('/contacts/bulk', { contacts }),
  update: (id, data) => api.put(`/contacts/${id}`, data),
  delete: (id) => api.delete(`/contacts/${id}`),
  bulkDelete: (contactIds) => api.post('/contacts/bulk-delete', { contactIds }),
  search: (query) => api.get(`/contacts/search/${query}`),
};

export const whatsappAPI = {
  getStatus: () => api.get('/whatsapp/status'),
  sendTest: (phoneNumber, message) => api.post('/whatsapp/send-test', { phoneNumber, message }),
  sendCampaign: (campaignId) => api.post(`/whatsapp/send-campaign/${campaignId}`),
  scheduleCampaign: (campaignId, scheduledTime) => 
    api.post('/whatsapp/schedule-campaign', { campaignId, scheduledTime }),
  getScheduled: () => api.get('/whatsapp/scheduled'),
  cancelScheduled: (id) => api.delete(`/whatsapp/scheduled/${id}`),
  updateScheduled: (id, scheduledTime) => 
    api.put(`/whatsapp/scheduled/${id}`, { scheduledTime }),
  logout: () => api.post('/whatsapp/logout'),
  
  // Configuration endpoints
  getConfig: () => api.get('/whatsapp/config'),
  updateConfig: (config) => api.post('/whatsapp/config', config),
  testBusinessApi: (apiKey, apiBaseUrl) => api.post('/whatsapp/test-business-api', { apiKey, apiBaseUrl }),
  
  // Business API templates
  getBusinessTemplates: (params) => api.get('/whatsapp/business-templates', { params }),
  getBusinessTemplate: (id) => api.get(`/whatsapp/business-templates/${id}`),
  syncTemplates: () => api.post('/whatsapp/sync-templates'),
};

export const blacklistAPI = {
  getAll: () => api.get('/blacklist'),
  add: (data) => api.post('/blacklist', data),
  remove: (id) => api.delete(`/blacklist/${id}`),
  check: (phoneNumber) => api.get(`/blacklist/check/${phoneNumber}`),
};

export const inboxAPI = {
  getAll: () => api.get('/inbox'),
  getConversation: (phoneNumber) => api.get(`/inbox/conversation/${phoneNumber}`),
  getConversations: () => api.get('/inbox/conversations'),
  markRead: (phoneNumber) => api.post('/inbox/mark-read', { phoneNumber }),
  getUnreadCount: () => api.get('/inbox/unread-count'),
  sendReply: (phoneNumber, message) => api.post('/inbox/send-reply', { phoneNumber, message }),
};

export const queueAPI = {
  getStats: () => api.get('/queue/stats'),
  clear: () => api.post('/queue/clear'),
  testSpintax: (template, contact) => api.post('/queue/test-spintax', { template, contact }),
};

export const networkAPI = {
  getTemplate: () => api.get('/network/template'),
  saveTemplate: (data) => api.post('/network/template', data),
  uploadFile: (formData) => {
    return api.post('/network/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  deleteFile: (filename) => api.delete(`/network/upload/${filename}`),
  sendMessage: (data) => api.post('/network/send', data),
  getHistory: (params) => api.get('/network/history', { params }),
};

export default api;
